<template>
  <el-form ref="searchForm" :model="searchFrom" class="searchBoxLine" inline>
    <el-form-item label="申请发货单号:" prop="partialDeliveryNum">
      <el-input v-model.trim="searchFrom.partialDeliveryNum" placeholder="请输入申请发货单号码" />
    </el-form-item>
    <el-form-item label="项目名称:" prop="projectName">
      <el-input v-model.trim="searchFrom.projectName" placeholder="请输入项目名称" />
    </el-form-item>
    <el-form-item label="合同编号:" prop="contractNum">
      <el-input v-model.trim="searchFrom.contractNum" placeholder="请输入合同编号" />
    </el-form-item>
    <el-form-item label="客户名称:" prop="customerName">
      <el-input v-model.trim="searchFrom.customerName" placeholder="请输入客户名称" />
    </el-form-item>
    <el-form-item label="部门:" prop="deptName">
      <el-input v-model.trim="searchFrom.deptName" placeholder="请输入部门" />
    </el-form-item>
    <el-form-item label="国家:" prop="overSeasSalesCountry">
      <el-input v-model.trim="searchFrom.overSeasSalesCountry" placeholder="请输入国家:" />
    </el-form-item>
    <el-form-item label="现销/赊销:" prop="markType">
      <el-select v-model="searchFrom.markType">
        <el-option label="全部" :value="''" />
        <el-option v-for="item in internationalSalesType" :key="item.code" :value="item.code" :label="item.name" />
      </el-select>
    </el-form-item>
    <el-form-item label="关务:" prop="customsName">
      <el-input v-model.trim="searchFrom.customsName" placeholder="请输入关务:" />
    </el-form-item>
    <el-form-item label="是否抛转成功:" prop="successfulSpin">
      <el-select v-model="searchFrom.successfulSpin">
        <el-option
          v-for="item in successfulSpinSelect"
          :key="item.code"
          :value="item.success"
          :label="item.name"
        />
      </el-select>
    </el-form-item>
    <div style="display: inline-block;">
      <el-form-item label="申请时间:" prop="startTime" style="margin-right: 0">
        <el-date-picker
          v-model="searchFrom.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        />
      </el-form-item>
      <div style="display: inline-flex;align-items:center;height: 28px;margin: 0 4px">
        -
      </div>
      <el-form-item prop="endTime">
        <el-date-picker
          v-model="searchFrom.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        />
      </el-form-item>
    </div>
    <el-form-item>
      <el-button type="primary" @click="doSearch">
        查询
      </el-button>
      <el-button type="default" @click="clearSearchForm">
        重置
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>

import { mapState } from 'vuex';
import { ApprovedListOrder } from '@/API/international.js';
export default {
  name: 'InvoiceProcessingSearchBox',
  props: {
    pagestate: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      searchFrom: {
        partialDeliveryNum: undefined, // 申请发货单号
        projectName: undefined, // 项目名称
        contractNum: undefined, // 合同编号
        customerName: undefined, // 客户名称
        deptName: undefined, // 部门
        overSeasSalesCountry: undefined, // 国家
        successfulSpin: undefined, // 是否抛转成功
        markType: undefined, // 现销/赊销
        customsName: undefined, // 关务
        startTime: undefined, // 申请时间
        endTime: undefined // 结束时间
      }
    };
  },
  computed: {
    // 下拉数据
    ...mapState('enumeration', ['internationalSalesType', 'successfulSpinSelect'])
  },
  methods: {
    doSearch () {
      this.tableloading = true;
      const params = {
        deliveryNum: this.searchFrom.partialDeliveryNum || undefined, // 申请发货单号
        contractNum: this.searchFrom.contractNum || undefined, //  合同编号
        projectName: this.searchFrom.projectName || undefined, // 项目名称
        startTime: this.searchFrom.startTime || undefined, // 开始申请时间
        endTime: this.searchFrom.endTime || undefined, // 结束申请时间
        agentName: this.searchFrom.customerName || undefined, // 客户名称
        departmentName: this.searchFrom.deptName || undefined, // 部门
        salesType: this.searchFrom.markType || undefined, // 现销/赊销
        overSeasSalesCountry: this.searchFrom.overSeasSalesCountry || undefined, // 国家
        successfulSpin: this.searchFrom.successfulSpin || undefined, // 是否抛转成功
        customsName: this.searchFrom.customsName || undefined, //  关务
        pageSize: this.pagestate.pageSize, //  每页显示几条数据
        pageIndex: this.pagestate.currentPage // 第几页
      };
      console.log('搜索入参', params.successfulSpin);
      /**
       * 接口
       */
      ApprovedListOrder(params).then(res => {
        this.$emit('ok', res);
      });
    },
    clearSearchForm () {
      this.$refs.searchForm.resetFields();
      this.doSearch();
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>

<style scoped>

</style>
